export default __webpack_public_path__ + "static/media/bwin_fantasy_pick_em_MPU_300x250_v2.da674242.png";